import http from "../../http";

export default {
  login: (params) => {
    return http.post("opservice/tenant/login", params);
  },
  yhtLogin: (params) => {
    return http.get("/opservice/userlogin/ykjcode/login", params);
  },
  info: (params) => {
    return http.get("opservice/tenant/current", params);
  },
  mobile: (params) => {
    return http.get("opservice/tenant/security/current/mobile", params);
  },
  getCodeByUser: (params) => {
    return http.post("opservice/enterpriseadmin/findpwd", params);
  },
  getCodeByUserPwd: (params) => {
    return http.post("opservice/enterpriseadmin/findpwd/verify", params);
  },
  resetPwd: (param) => {
    return http.post("opservice/enterpriseadmin/resetpwd", param);
  },
  existsMobile: (params) => {
    return http.post("opservice/regist/existsmobile", params);
  },
  existsCode: (params) => {
    return http.post("opservice/regist/iscode", params);
  },
  getcode: (params) => {
    return http.get("marketcenter/api/sms/v2/code/with/captcha/html/page", params);
  },
  // 别名：原 clue/user 模块的 hidefield (opservice/tenantconf/current)
  hidefield: (data) => {
    return http.post("opservice/tenantconf/current", data);
  },
  // 别名：原 wechat 模块的 getdata (opservice/tenantconf/current, GET method)
  getdata: (params) => {
    return http.get("opservice/tenantconf/current", params);
  },
};
